import { useSyncExternalStore } from 'react';
import { onlineManager } from '@tanstack/react-query';

/**
 * Acerta o estado inicial da rede com o que o navegador diz.
 *
 * O `onlineManager` do TanStack comeca como "online" e so muda quando um evento
 * `online`/`offline` chega. Quem recarrega a pagina ja sem rede nunca recebe
 * esse evento: o app acreditava estar conectado, o indicador do rail nao
 * aparecia e as consultas iam a rede em vez de pausar. Achado da Fase 9 da
 * campanha de verificacao, encontrado no navegador de verdade.
 *
 * Roda na importacao de proposito: e estado de plataforma, e esquecer de
 * chamar em algum ponto de entrada traria o bug de volta sem aviso.
 */
if (typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean') {
  onlineManager.setOnline(navigator.onLine);
}

/**
 * Se há rede, segundo o mesmo juiz que pausa as consultas e a fila. Usar
 * `navigator.onLine` direto daria respostas diferentes das do cache em alguns
 * instantes, e o indicador do rail mentiria.
 */
export function useOnline(): boolean {
  return useSyncExternalStore(
    (aviso) => onlineManager.subscribe(aviso),
    () => onlineManager.isOnline(),
    // No servidor e nos testes sem `navigator`, assume-se conectado.
    () => true,
  );
}
